import type { TOC } from '@ember/component/template-only';
import LoadingBar from 'lumen/components/general/loading-bar';

import styles from './breakdown-value-loading.module.css';

interface ParityInsightBreakdownValueLoadingSignature {
  Args: {};
}

const ParityInsightBreakdownValueLoading = <template>
  <div class={{styles.container}}>
    <LoadingBar />
    <LoadingBar class="w-full" />
  </div>
</template> satisfies TOC<ParityInsightBreakdownValueLoadingSignature>;

export default ParityInsightBreakdownValueLoading;
